<template>
  <div class="download-app-card">
    <p class="download-app-card_title">
      {{ title }}
    </p>
    <p class="download-app-card_content">
      {{ content }}
    </p>
    <div class="download-button">
      <WsButton001
        primary
        width-stretch
        @click="$_downloadClick()"
      >
        {{ $t('下載',{item:'LLESH'}) }}
      </WsButton001>
    </div>
    <WsTextButton001
      primary
      no-padding
      to="/board-overview"
    >
      {{ btnText }}
    </WsTextButton001>
  </div>
</template>
<script>
export default {
  name: "DownloadAppCard",
  props: {
    title: {
      type: String,
      default() {
        return `${this.$t("歡迎回來ESGoal")}`;
      },
    },
    content: {
      type: String,
      default() {
        return this.$t("為了提供更佳的使用體驗，請前往下載APP。");
      },
    },
    btnText: {
      type: String,
      default() {
        return this.$t("回到首頁");
      },
    },
  },
  methods: {
    $_downloadClick() {
      window.open("https://www.google.com");
    },
  },
};
</script>
<style lang="scss" scoped>
.download-app-card {
  @include flex_align;
  flex-direction: column;
  padding: 36px 24px 24px;
  width: 100%;
  border-radius: 10px;
  background-color: var(--white);
  .download-app-card_title {
    font-size: 1.5rem;
    font-weight: bold;
    line-height: 1.17;
    letter-spacing: 0.6px;
    text-align: center;
    color: var(--gray-900);
  }
  .download-app-card_content {
    @include auto_margin_top(24px);
    font-size: 1.125rem;
    line-height: 1.33;
    text-align: center;
    color: var(--gray-900);
  }
  .download-button {
    @include auto_margin_top(24px);
    width: 100%;
    .gradient-button {
      height: 56px;
      &:before {
        height: 56px;
      }
    }
  }
  .ws-text-button {
    @include auto_margin_top(21px);
  }
}
</style>